import { Col, Row } from 'antd';
import { INPUT_TYPE } from 'components/common/Input/types';
import React, { useCallback } from 'react';
import IntlMessages from 'utils/IntlMessages';

import {
  ActionButtonStyled,
  InputComponentStyled,
  WarningMessageContainerRowStyled,
  WarningMessageStyled,
} from '../styled';
import {
  DayTransitionWordContainerStyled,
  TimePickerInputContainerStyled,
  TimePickerSectionContainerStyled,
} from './styled';
import { IAvailabilityDayFormProps } from './types';

const AvailabilityTimeForm: React.FC<IAvailabilityDayFormProps> = ({
  times,
  onAddMoreClick,
  onClearTimeClick,
  onTimePick,
  currentDayInvalidTimeRangeError,
  currentDayOverlappedStatus,
  currentDayInvalidTimeValueError,
}) => {
  const generateTimeForm = useCallback(
    (time, index: number) => {
      const isAddRowButtonNeeded = index === times.length - 1;
      const isAddRowButtonDisabled = !times[index].from || !times[index].to;
      const worktimeId = time.id;
      const isOverlappedError =
        currentDayOverlappedStatus &&
        currentDayOverlappedStatus[worktimeId] &&
        Object.values(currentDayOverlappedStatus[worktimeId]).some((val) => val);
      const isTimeRangeInValidError = currentDayInvalidTimeRangeError && currentDayInvalidTimeRangeError[index];
      const isTimeValueInvalidError = currentDayInvalidTimeValueError && currentDayInvalidTimeValueError[index];

      let timeWarningTranslationId = '';
      if (isOverlappedError) timeWarningTranslationId = 'timeOverlappedWarning';
      if (isTimeRangeInValidError) timeWarningTranslationId = 'invalidTimeRangeWarning';
      if (isTimeValueInvalidError) timeWarningTranslationId = 'invalidTimeValueWarning';

      return (
        <Col span={24} key={worktimeId} className='gx-px-0'>
          <Row align='top'>
            <TimePickerSectionContainerStyled className='gx-p-0'>
              <Row className='gx-flex-nowrap'>
                <TimePickerInputContainerStyled className='gx-p-0'>
                  <InputComponentStyled
                    $error={isOverlappedError || isTimeRangeInValidError || isTimeValueInvalidError}
                    type={INPUT_TYPE.TIME_PICKER}
                    value={times[index].from || undefined}
                    onChange={(v) => {
                      onTimePick(v, index, 'from');
                    }}
                    name={`day-from-${index}`}
                  />
                </TimePickerInputContainerStyled>
                <DayTransitionWordContainerStyled className='gx-px-3 ant-form-item'>
                  <span>To</span>
                </DayTransitionWordContainerStyled>
                <TimePickerInputContainerStyled className='gx-p-0'>
                  <InputComponentStyled
                    $error={isOverlappedError || isTimeRangeInValidError || isTimeValueInvalidError}
                    type={INPUT_TYPE.TIME_PICKER}
                    // defaultValue={workTime.to}
                    name={`day-to-${index}`}
                    value={times[index].to || undefined}
                    onChange={(v) => {
                      onTimePick(v, index, 'to');
                    }}
                  />
                </TimePickerInputContainerStyled>
                <Col className='gx-p-0 gx-m-0' flex='auto'>
                  <ActionButtonStyled
                    className='gx-trans-del-btn'
                    $padding='0 30px'
                    $danger
                    $noBorder
                    $bgColor='transparent'
                    onClick={() => {
                      onClearTimeClick(index);
                    }}>
                    <span className='icon icon-trash' />
                  </ActionButtonStyled>
                </Col>
              </Row>
            </TimePickerSectionContainerStyled>

            {isAddRowButtonNeeded && (
              <TimePickerSectionContainerStyled className='gx-p-0 gx-m-0'>
                <ActionButtonStyled
                  $padding='0 30px'
                  type='dashed'
                  disabled={isAddRowButtonDisabled}
                  onClick={onAddMoreClick}>
                  <span style={{ fontSize: '16px' }}>+&nbsp;</span>
                  <span>
                    <IntlMessages id='userProfile.addRow' />
                  </span>
                </ActionButtonStyled>
              </TimePickerSectionContainerStyled>
            )}
            {(isOverlappedError || isTimeRangeInValidError || isTimeValueInvalidError) && (
              <WarningMessageContainerRowStyled className='gx-p-0' span={24}>
                <Row align='middle'>
                  <WarningMessageStyled>
                    <IntlMessages id={`userProfile.availability.${timeWarningTranslationId}`} />
                  </WarningMessageStyled>
                </Row>
              </WarningMessageContainerRowStyled>
            )}
          </Row>
        </Col>
      );
    },
    [times],
  );

  return <>{times && times.map(generateTimeForm)}</>;
};

export default React.memo(AvailabilityTimeForm);
